import React, { Component } from 'react';
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import trLocale from '@fullcalendar/core/locales/tr';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import CalendarNote from './CalendarNote';
import { Button } from "antd";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";
import Alert from "react-s-alert";
import {showAxiosError} from "../../util/Helpers";
class IndividualCalendars extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: [],
            selectedDate: null,
            currentEvent: {
                id: null,
                title: "",
                time: "",
                date: "",
                note: ""
            },
            isFormVisible: false,
            isConfirmationModalVisible: false,
            calenderList:[],
        };
        this.calendarRef = React.createRef();
        this.deleteEvent = this.deleteEvent.bind(this);
        this.listCalender=this.listCalender.bind(this);
    }
    handleDateClick = (arg) => {
        const { date } = arg;

        if (this.state.currentEvent.id === null) {
            const correctDate = new Date(date.setHours(date.getHours()+3))
            this.setState({
                selectedDate: correctDate.toISOString(),
                isFormVisible: true,
                isConfirmationModalVisible: false,
            });
        } else {
            this.setState({
                selectedDate: null,
                currentEvent: {
                    id: null,
                    title: "",
                    time: "",
                    date: "",
                    note: ""
                },
                isFormVisible: true,
                isConfirmationModalVisible: false,
            });
        }
    };
    listCalender() {
        let self = this;
        let params = {
            url: API_BASE_URL+'/calender/listCalender' ,
            method: "get",
        };
        self.setState({loading: true});
        request(params)
            .then(function (response) {
                let calenderList = response.data;
                self.setState({
                    calenderList,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }
    handleEventClick = (info) => {
        this.setState({
            currentEvent: {
                id: info.event.toPlainObject().id,
                title: info.event.toPlainObject().title,
                time: info.event.toPlainObject().extendedProps.time,
                date: info.event.start.toISOString(),
                note: info.event.toPlainObject().extendedProps.note
            },
            selectedDate: info.event.start.toISOString(),
            isFormVisible: true,
            isConfirmationModalVisible: false,
        });
    };
    deleteEvent(eventId) {
        const {events} = this.state;
        let params;
        let data;
        let message;
        let self=this;
        if (eventId !== null) {

            message = 'Etkinlik Başarıyla Silindi.'
            params = {
                url: API_BASE_URL + "/calender/" + eventId,
                data: data,
                method: 'delete'
            };
            setTimeout(function(){
                window.location.reload();
            }, 3000);
            request(params).then(() => {
                Alert.success(
                    message, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                self.setState({isLoading: false});
                const updatedEvents = events.filter(event => event.id != eventId);
                this.setState({
                    events: updatedEvents,
                });
            }).catch(function (error) {
                self.setState({isLoading: false});
                showAxiosError(error);
            });


        }
        this.setState({
            isFormVisible: false,
            isConfirmationModalVisible: false,
        });
    }
    closeConfirmationModal = () => {
        this.setState({
            isConfirmationModalVisible: false,
        });
    };
    saveEvent = (newEvent) => {
        const { events, selectedDate, currentEvent } = this.state;

        if (currentEvent.id === null) {
            this.setState((prevState) => ({
                events: [...prevState.events, { ...newEvent, id: newEvent.id }],
                selectedDate: null,
                isFormVisible: false,
                currentEvent: { id: null}
            }));
        } else {
            const updatedEvents = events.map(event => {
                if (event.id == currentEvent.id) {
                    return { ...event, ...newEvent };
                }else {
                    return event;
                }
            });
            this.setState({
                events: updatedEvents,
                selectedDate: null,
                isFormVisible: false,
                currentEvent: { id: null }
            });

        }
    };
    componentDidMount(){
        this.listCalender();
    }
    formatEvents = (data) => {
        return data.map(event => {
            return {
                id: event.id,
                title: event.title,
                start: event.start,
                time: event.time,
                note: event.note
                // Diğer gerekli bilgileri ekleyebilirsiniz.
            };
        });
    };
    render() {
        const { events, currentEvent, isFormVisible } = this.state;
        const events2 = this.formatEvents(this.state.calenderList);
        return (
            <div className="App">
                <FullCalendar
                    defaultView="dayGridMonth"
                    ref={this.calendarRef}
                    header={{
                        left: "prev,next",
                        center: "title",
                        right: "dayGridMonth,timeGridWeek,timeGridDay",
                    }}
                    themeSystem="simple-silver"
                    plugins={[dayGridPlugin, interactionPlugin]}
                    locale={trLocale}
                    events={events2}
                    dateClick={this.handleDateClick}
                    eventClick={this.handleEventClick}
                    eventContent={(arg) => {
                        return (
                            <div style={{ backgroundColor: '#dadada', border: '1px solid #dadada' ,textAlign:"center" }}>
                                <button onClick={() => this.setState({ isFormVisible: false, isConfirmationModalVisible: true })} style={{ background: 'red', left: '100px', top: '-11px', padding: '5px', opacity: '0.6' }} className="Btn btn-sm btn-icon"><strong>X</strong></button>
                                <h2 style={{ color: 'black' }}>{arg.event.title}</h2>
                                <h2 style={{ color: 'black' }}>{arg.event.extendedProps.note}</h2>
                                <h4 style={{ color: '#e54343' }}>{arg.event.extendedProps.time}</h4>
                            </div>
                        );
                    }}
                />
                <Modal isOpen={isFormVisible} size="md" className="ust">
                    <ModalHeader toggle={() => this.setState({ isFormVisible: false })}>Yapılacaklar</ModalHeader>
                    <ModalBody>
                        <CalendarNote
                            onSave={this.saveEvent}
                            onCancel={() => this.setState({ isFormVisible: false })}
                            currentEvent={currentEvent}
                            selectedDate={this.state.selectedDate}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.isConfirmationModalVisible} toggle={this.closeConfirmationModal}>
                    <ModalHeader toggle={this.closeConfirmationModal}>Etkinliği Sil</ModalHeader>
                    <ModalBody>
                        <div style={{textAlign:"center"}}>
                        <p>Bu etkinliği silmek istediğinizden emin misiniz?</p>
                        <Button color="danger" onClick={() => this.deleteEvent(currentEvent.id)}>Sil</Button>
                        <Button color="secondary" onClick={this.closeConfirmationModal}>İptal</Button>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}
export default IndividualCalendars;



// WEBPACK FOOTER //
// ./src/page/agenda/individualCalendars.js